import React from 'react';

const TeamIntroduction = () => {
  return (
    <div style={{ fontFamily: "jost, sans-serif", backgroundColor: "#f9fafb" }} className="min-h-screen flex flex-col">
    

      {/* Main Content */}
      <main className="flex-grow flex items-center justify-center py-4 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto text-center">
          <div className=" rounded-xl shadow-lg p-8 md:p-12">
            {/* Icon/Illustration */}
            <div className="mb-2">
              <div className="w-32 h-32 mx-auto bg-blue-100 rounded-full flex items-center justify-center">
                <svg className="w-16 h-16 text-[#063970]" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                </svg>
              </div>
            </div>

            {/* Heading */}
            <h2 className="text-3xl font-bold text-gray-800 mb-4">
              Meet Our Team
            </h2>

            {/* Message */}
            <p className="text-lg text-gray-600 mb-8">
              We're excited to introduce you to the talented professionals behind our lighting solutions. 
              Our team page is currently under development and will be available soon.
            </p>

            {/* Countdown or Progress Indicator (Optional) */}
            {/* <div className="mb-8">
              <div className="w-full bg-gray-200 rounded-full h-2.5">
                <div className="bg-blue-600 h-2.5 rounded-full" style={{width: '75%'}}></div>
              </div>
              <p className="text-sm text-gray-500 mt-2">Page in progress - 75% complete</p>
            </div> */}

            {/* Contact Information */}
            {/* <div className="bg-blue-50 rounded-lg p-4 mb-8">
              <h3 className="text-lg font-semibold text-blue-800 mb-2">In the meantime</h3>
              <p className="text-blue-700">
                Feel free to contact us directly at <span className="font-medium">info@lighting-solutions.com</span> or call <span className="font-medium">+1 (555) 123-4567</span>
              </p>
            </div> */}

            {/* Back Button */}
            <a 
              href="/" 
              className="inline-flex items-center px-6 py-3 border border-transparent text-md font-medium rounded-md text-white bg-blue-600 hover:bg-[#063970] transition duration-300"
            >
              <svg className="w-5 h-5 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
              </svg>
              Return to Home
            </a>
          </div>
        </div>
      </main>

     
    </div>
  );
};

export default TeamIntroduction;